import { Link } from "react-router-dom";
import PolicyShell from "../../../components/policy/PolicyShell";


const AntiTraffickingPolicy = () => (
    <PolicyShell title="Anti-Trafficking Policy" updated="October 2026">
        <section>
            <h2 className="text-lg font-semibold mb-3">1. Our Position</h2>
            <p>
                TLK does not condone human trafficking, sex trafficking, forced labor, or any
                form of exploitation. These activities are strictly prohibited on our platform
                and in any content, account, or conduct connected to our Service.
            </p>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">2. Reporting to Authorities</h2>
            <p>
                All instances of suspected human trafficking will be reported to the proper
                authorities. We will cooperate with law enforcement investigations as required
                by applicable law.
            </p>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">3. How We Prevent Exploitation</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Creators are reviewed, contracted, and onboarded directly by TLK; there is no open self-service creator sign-up</li>
                <li>Every user must confirm they are 18 or older before accessing the site</li>
                <li>Content that appears to depict coerced, non-consenting, or exploited persons is removed</li>
                <li>Accounts connected to suspected trafficking are suspended or terminated</li>
            </ul>
        </section>
        <section>
            <h2 className="text-lg font-semibold mb-3">4. Report a Concern</h2>
            <p className="mb-2">
                If you suspect trafficking or exploitation connected to TLK, contact us at{' '}
                <a className="underline" href="mailto:support@tlknow.ai">support@tlknow.ai</a>{' '}
                or use our <Link className="underline" to="/complaints-policy">Complaints &amp; Content Removal Policy</Link>.
            </p>
            <p>
                If someone is in immediate danger, contact local emergency services. In the
                United States you can also call the National Human Trafficking Hotline at
                1-888-373-7888 or text 233733.
            </p>
        </section>
    </PolicyShell>
);

export default AntiTraffickingPolicy;